import React, { useState, useEffect } from 'react';
import { isEmpty, update, constant } from 'lodash';
import { Typography, CircularProgress } from '@material-ui/core';

import TestResults from 'components/commons/test-results';
import ObservationForm from 'components/views/observations/form';
import useStyles from './EditObservation.styles';

const EditObservation = ({ actions, facts, insight, insightId, labels }) => {
  const classes = useStyles();
  const [form, setForm] = useState({});
  useEffect(() => {
    actions.onMount();
    actions.fetchObservation(insightId);
    return () => actions.onUnmount();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(insight.insight)) setForm(insight.insight);
  }, [insight]);

  const handleChange = name => e => setForm({ ...update(form, name, constant(e.target.value)) });

  const handleCheck = name => e => setForm({ ...update(form, name, constant(e.target.checked)) });

  const handleSubmit = () => actions.updateObservation(form);

  const { testPassed, testResults } = insight;

  return (
    <div className={classes.pageContainer}>
      <div className={classes.headerContainer}>
        <Typography variant="h5" display="inline">
          Edit Observation
        </Typography>
        <div className={classes.testContainer}>
          <TestResults testPassed={testPassed} testResults={testResults} />
        </div>
      </div>
      {isEmpty(form) || insight.isFetching ? (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      ) : (
        <ObservationForm
          facts={facts}
          form={form}
          handleChange={handleChange}
          handleCheck={handleCheck}
          labels={labels}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default EditObservation;
